// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class RecordingSegment {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): RecordingSegment {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  startTime(): bigint {
    return this.bb!.readUint64(this.bb_pos)
  }

  endTime(): bigint {
    return this.bb!.readUint64(this.bb_pos + 8)
  }

  static sizeOf(): number {
    return 16
  }

  static createRecordingSegment(
    builder: flatbuffers.Builder,
    start_time: bigint,
    end_time: bigint
  ): flatbuffers.Offset {
    builder.prep(8, 16)
    builder.writeInt64(BigInt(end_time ?? 0))
    builder.writeInt64(BigInt(start_time ?? 0))
    return builder.offset()
  }
}
